import { useInfiniteQuery } from '@tanstack/react-query'

import { getDevicesForSale } from '@/lib/api/marketplace'
import { MarketplaceDevices } from '@/lib/types'

import { useDeviceFilterStore } from '@/hooks/stores/useDeviceFilterStore'
import useUserInfo from '@/hooks/users/useUserInfo'

const useDevicesForSale = () => {
  const { currency } = useUserInfo()

  const { totalPrice, pricePerTH, locationId, sort, order, preorder } =
    useDeviceFilterStore()

  const { isFetching, isFetchingNextPage, data, fetchNextPage } =
    useInfiniteQuery<MarketplaceDevices>({
      queryKey: [
        'marketplace-devices',
        currency,
        sort,
        order,
        preorder,
        locationId,
        totalPrice,
        pricePerTH
      ],
      queryFn: ({ pageParam = 1 }) =>
        getDevicesForSale({
          page: pageParam,
          currency,
          sort,
          order,
          preorder,
          locationId,
          totalPrice,
          pricePerTH
        }),
      keepPreviousData: true,
      getNextPageParam: (_lastPage, pages) => {
        return pages[0].total > 0 && pages[pages.length - 1].devices.length > 0
          ? pages.length + 1
          : undefined
      }
    })

  return { data, isFetching, isFetchingNextPage, fetchNextPage }
}

export default useDevicesForSale
